import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { InfoPill } from '../../../../elementals';
import { ColorNames } from '../../../../../constants';
import classnames from 'classnames/bind';
import styles from '../styles.scss';
const cx = classnames.bind(styles);
const BidRankActionPill = ({ isMobile, action, duration, onTimeout, }) => {
    useEffect(() => {
        if (!duration || !onTimeout) {
            return;
        }
        const timer = setTimeout(() => {
            onTimeout();
        }, duration);
        return () => {
            clearTimeout(timer);
        };
    }, []);
    return (_jsx(InfoPill, { className: cx('action-pill'), size: isMobile ? 'small' : 'medium', content: action, backgroundColor: ColorNames.InfoExtraLight, foregroundColor: ColorNames.Info, includeBorder: true }));
};
export default BidRankActionPill;
//# sourceMappingURL=index.js.map